import type {
  BreadcrumbLabelContext,
  BreadcrumbMemberContext,
} from '../../layout/navigation/nonAdminBreadcrumbModel';

const FALLBACK_MEMBER_LABEL = 'Member';

type BuildSummaryBreadcrumbOverridesInput = {
  memberId: string | null;
  memberLabel: string | null;
  summaryLabel: string | null;
};

export type SummaryBreadcrumbOverridesValue = {
  labels?: Pick<BreadcrumbLabelContext, 'summaryLabel'>;
  memberContext?: BreadcrumbMemberContext | null;
};

const normalizeValue = (value: string | null): string | null => {
  if (!value) {
    return null;
  }

  const trimmedValue = value.trim();
  return trimmedValue.length > 0 ? trimmedValue : null;
};

export const buildSummaryBreadcrumbOverrides = ({
  memberId,
  memberLabel,
  summaryLabel,
}: BuildSummaryBreadcrumbOverridesInput): SummaryBreadcrumbOverridesValue => {
  const normalizedMemberId = normalizeValue(memberId);
  const normalizedMemberLabel = normalizeValue(memberLabel);
  const normalizedSummaryLabel = normalizeValue(summaryLabel);

  return {
    memberContext: normalizedMemberId
      ? {
          memberId: normalizedMemberId,
          memberLabel: normalizedMemberLabel ?? FALLBACK_MEMBER_LABEL,
        }
      : null,
    // Explicitly include the key so context merge can clear stale labels.
    labels: {
      summaryLabel: normalizedSummaryLabel ?? undefined,
    },
  };
};
